module.exports = __webpack_public_path__ + "img/23.1a7b1e24.png";